import React from 'react';

const Sider = () => {
    return (
        <div className="col sidebar grey lighten-4" >

            <div className="quote amber-text">
            </div>

            <div className="candidate-avatar-container amber accent-2">
                <img src={`${process.env.PUBLIC_URL}/assets/images/profile/pavancha_01.jpg`} className="img-fluid" alt="profile_img" />
            </div>

            <div className="profile cyan lighten-2">
                <section className="headeline">
                    <h6 className="heading-small">
                        <span>Profile</span>
                    </h6>
                    <div className="section-content">
                                    A Programmer, Lifelong learner, Curious child. :) Experienced Software Developer with a demonstrated history of working in the telecommunications industry. Skilled in JavaScript, ES6, React JS, Redux, Angular, Java, PhoneGap, PHP, Ionic Framework, C++, and Backbone.js. Strong engineering professional with a Bachelor of Engineering (B.E.) focused in Computer Engineering from University of Pune.
                    </div>
                </section>

                <section className="contatct-infromation">
                    <h6 className="heading-small">
                        <span>Contact</span>
                    </h6>
                    <div className="section-content">
                        <div className="contact-option">
                            <label className="sub-heading d-block"><span>Phone</span></label>
                            <span>+91 808 770 8588/ 797 227 7485</span>
                        </div>
                        <div className="contact-option">
                            <label className="sub-heading d-block"><span>E-mail</span></label>
                            <span><a href="mailto:chaudharipavan@outlook.com?Subject=Ref:%20Portfolio">chaudharipavan@outlook.com</a></span>
                        </div>
                    </div>
                </section>

                <section className="highlights-infromation">
                    <h6 className="heading-small">
                        <span>Highlights</span>
                    </h6>
                    <div className="section-content">
                        <p>Amdocs Lifelong Learning MOOC : Advanced - <strong>2018</strong></p>
                        <p>Amdocs DevOps Fundamentals - <strong>2018</strong></p>
                        <p>AMCAT Certified Software Development Trainee - <strong>2014</strong></p>
                        <p>Technical Head of 'Computer Engineering Students Association' - <strong>2009</strong></p>
                    </div>
                </section>

                <section className="hobbies-infromation">
                    <h6 className="heading-small">
                        <span>Hobbies</span>
                    </h6>
                    <div className="section-content">
                        <p>Learning</p>
                        <p>Programming</p>
                        <p>Watching Movies and TV Series</p>
                        <p>Listening to Music</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Sider;
